export default __webpack_public_path__ + "static/media/SpamBurner Black.05dfef9d.svg";